export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6845.d4a71aab.jpg";